import http from "@/http-common.js";

class ClientsService {

  basePathApiService = "/clients";
 
  getAll(params) {
    return http.get(this.basePathApiService, params);
  } 

  getArchiveAll(params) {
    return http.get(this.basePathApiService + '/archive', params);
  } 

  getBlackListAll(params) {
    return http.get(this.basePathApiService + '/blacklist', params);
  } 

  create(createData) {
    return http.post(this.basePathApiService, createData);
  }
  editMultiple(id, editData) {
    return http.put(this.basePathApiService + `/${id}`, editData);
  }
  delete(id) {
    return http.delete(this.basePathApiService + `/${id}`);
  }
  
 
}
export default new ClientsService();
